import { render, staticRenderFns } from "./CurriculumnDetailCard.vue?vue&type=template&id=4c34e1be"
import script from "./CurriculumnDetailCard.vue?vue&type=script&lang=js"
export * from "./CurriculumnDetailCard.vue?vue&type=script&lang=js"
import style0 from "./CurriculumnDetailCard.vue?vue&type=style&index=0&id=4c34e1be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports